/**
 * Single source of truth for the integrations module base path. The module
 * lives inside Organisation Settings — components must never hardcode the
 * path (it moved once already, from top-level /integrations).
 */
export const INTEGRATIONS_BASE_PATH = "/organisation/integrations";

export function integrationDashboardPath(integrationId: string): string {
  return `${INTEGRATIONS_BASE_PATH}/${integrationId}/dashboard`;
}

export function integrationSettingsPath(integrationId: string): string {
  return `${INTEGRATIONS_BASE_PATH}/${integrationId}/settings`;
}

export function integrationCreatePath(integrationId: string): string {
  return `${integrationSettingsPath(integrationId)}?mode=create`;
}
